import EmailNotVerifiedMessage from "@Components/app/notifications/EmailNotVerifiedMessage";
import { AppContext } from "@Context/common/general/context";
import { useCallback, useContext } from "react";
import { defineNotificationModule, INotificationResolverProps } from "../notification-service.types";
import { useAccountInfoResolved } from "../shared/use-account-info-resolved";
import { useNotificationActions } from "../shared/use-notification-actions";
import { useNotificationCandidate } from "../use-notification-candidate";

const id = "EMAIL_VERIFICATION";

const EmailVerificationNotificationResolver = ({ priority }: INotificationResolverProps) => {
  const { state } = useContext(AppContext);
  const { handleLogout } = useNotificationActions();
  const accountInfoResolved = useAccountInfoResolved(state.user.authenticated);
  const isActive = state.user.emailVerified === false && accountInfoResolved && state.user.authenticated && state.device.isUnityEmbedded;

  const render = useCallback(() => <EmailNotVerifiedMessage onLogout={handleLogout} />, [handleLogout]);

  useNotificationCandidate({
    id,
    priority,
    isActive,
    render,
  });

  return null;
};

export const emailVerificationNotification = defineNotificationModule({
  id,
  Resolver: EmailVerificationNotificationResolver,
});
